import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import ConfigReducer from './ConfigReducer';
import CreateOrdersReducer from './CreateOrdersReducer';
import EditOrderReducer from './EditOrderReducer';
import OrderReducer from './OrderReducer';

const rootReducer = combineReducers({
  auth: AuthReducer,
  config: ConfigReducer,
  createOrders: CreateOrdersReducer,
  editOrder: EditOrderReducer,
  order: OrderReducer,
});

export default rootReducer;
